<template>
    <div class="content content-full">
        <ul class="lista-cat">
            <li class="cat-consigli text-uppercase" v-if="this.advices.length">
                <router-link :to="{name:'menu.category.advices', query:{ids:this.advices}}">
                    <img src="/img/be/ico-consigli.png" width="25" class="mr-3">{{$t('consigliperte')}}
                </router-link>
            </li>
            <li v-for="category in this.categories">
                <router-link :to="{name:'menu.category.products', params:{id:category.id}}">
                    {{category.alias}}
                    <div v-if="category.descrizione">
                        <span class="f1">
                            {{category.descrizione.ellipsis(40)}}
                        </span>
                    </div>
                </router-link>
            </li>
        </ul>
        <p class="gray text-center padding" v-if="this.general_notes">
            {{$t('note_generali_label')}} : <span v-html="this.general_notes"></span>
        </p>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {getCategoriesList} from '../../api/restaurant';

export default {
    name: "Categories",
    data() {
        return {
            general_notes: '',
            advices: [],
            categories: []
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    watch: {
        language: function () {
            this.fetch();
        }
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getCategoriesList(this.language, {
                id_ristorante: this.id_ristorante,
                id_menu: this.order.id_menu,
                id_locale: this.locale.id,
                api_key: this.user.api_key,
            }).then((response) => {
                this.advices = response.consigli;
                this.general_notes = response.note_generali ? response.note_generali.replace('\n', '<br>') : '';
                this.categories = response.categorie_prodotti_lista;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
